var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mt-16"},[_c('div',{staticClass:"echarts"},[_c('div',{staticStyle:{"width":"460px","margin":"0 auto","height":"290px"},attrs:{"id":"size"}})])])])
}]

export { render, staticRenderFns }